import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=e08aacd0&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=e08aacd0&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08aacd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e08aacd0')) {
      api.createRecord('e08aacd0', component.options)
    } else {
      api.reload('e08aacd0', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=e08aacd0&scoped=true&", function () {
      api.rerender('e08aacd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pRqTuiL3Uvd5/JS/comp/Paginate.vue"
export default component.exports